import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Box, ButtonBase, InputBase, makeStyles, Typography, Checkbox, FormControlLabel } from '@material-ui/core';
import _, { isArray } from 'lodash';
import { useSelector } from 'react-redux';
import { systemAPI } from '../../../../apis';
import { AutoCompleteSelect } from '../../../../components';
import { i18n } from '../../../../language';
import { AddIcon } from '../../../../components/Icon';
import { rewriteSettingRequestParams } from '../../../../utils/check';
import AutoCompleteInput from '../../../../components/AutoCompleteInput';
import LongRemark from '../../../../components/LongRemark';
import lightNoImg from '../../../../static/images/light_no.png';
import lightOffImg from '../../../../static/images/light_off.png';
import { classNames, getUUID, initValue, useGetUserInfo } from '../../../../utils';
import { authNameE } from '../../../../utils/userFuncs';
import ResetDialog from './ResetDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0 1.875rem',
    display: 'flex',
    flexDirection: 'column',
  },
  databaseMapping: {
    padding: '1.813rem 0 1.563rem 0',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  label: {
    height: '2.375rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#7d86a9',
  },
  InputBase: {
    height: '3.5rem',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    width: '100%',
    paddingLeft: '1.25rem',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      color: '#2e4469',
      fontFamily: 'NotoSans-Medium',
    },
  },
  save: {
    width: '7.25rem',
    height: '3rem',
    borderRadius: '0.625rem',
    backgroundColor: '#4c93ff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
    marginBottom: '1rem',
  },
  srsCtr: {
    display: 'flex',
  },
  addSRS: {
    color: '#538fff',
    fontSize: '1rem',
    fontWeight: '500',
    alignSelf: 'flex-start',
    fontFamily: 'NotoSans-Medium',
    // marginTop: '-0.2rem',
    marginBottom: '1.75rem',
  },
  addLocation: {
    color: '#538fff',
    fontSize: '1rem',
    fontWeight: '500',
    alignSelf: 'flex-start',
    fontFamily: 'NotoSans-Medium',
    // marginTop: '-0.2rem',
    marginBottom: '1rem',
  },
  addIcon: {
    width: '1.438rem',
    height: '1.438rem',
    marginRight: '0.813rem',
  },
  connectButton: {
    width: '6.25rem',
    height: '2.625rem',
    fontSize: '1rem',
    color: '#538fff',
    fontWeight: '500',
    backgroundColor: '#f5faff',
    padding: '0.625rem 0.5rem 0.75rem',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    border: '1px solid #538fff',
  },
  resetBtn: {
    width: '2.5rem',
    fontSize: '1rem',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#1973e6',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontFamily: 'NotoSans-Medium',
    marginLeft: '0.5rem',
  },
  inputBox: {
    height: '3.5rem',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    paddingLeft: '1.2rem',
    paddingRight: '1.2rem',
  },
  inputBoxBase: {
    width: '100%',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      color: '#2e4469',
      fontFamily: 'NotoSans-Medium',
    },
  },
  alertLightImg: {
    width: '2.75rem',
    height: '2.75rem',
    objectFit: 'contain',
  },
  alertLightText: {
    fontSize: '0.87rem',
    fontWeight: 'bold',
    color: '#7d86a9',
    marginLeft: '0.313rem',
  },
  alertLightButton: {
    width: '6.25rem',
    height: '2.625rem',
    fontSize: '1rem',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    borderRadius: '10px',
    padding: '0.688rem 0',
    marginLeft: '4.375rem',
  },
  alertLightButtonOFF: {
    backgroundColor: '#ff7270',
  },
  alertLightButtonON: {
    backgroundColor: '#28d2ab',
  },
  alertLightButtonDisable: {
    backgroundColor: '#c0c6cb',
  },
  checkBox: {
    marginLeft: '0rem',
    marginBottom: '1.75rem',
    '& .MuiButtonBase-root': {
      padding: '0',
      paddingRight: '0.938rem',
    },
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
}));

const handleSelectTypeInput = ({
  name,
  hospitalWardList,
  data,
  setInputValues,
  InputValues,
  alarmId,
  itemData,
  updateLisStatusApi,
}) => {
  if (name === 'hospital') {
    const hospIndex = _.findIndex(hospitalWardList, (item) => {
      return item.hospitalId === data;
    });
    const wards = hospitalWardList[hospIndex].wards;

    let ward = {
      value: '',
      index: -1,
    };

    if (wards?.length >= 0) {
      ward = {
        value: wards[0].wardId,
        index: 0,
      };
    }

    setInputValues({
      ...InputValues,
      hospital: { value: data, index: hospIndex },
      ward,
    });
  } else if (name === 'ringtone') {
    const newInputValue = JSON.parse(JSON.stringify(InputValues));
    const idx = newInputValue.alarm.findIndex((it) => it.alarmId === alarmId);
    if (idx > -1) {
      newInputValue.alarm[idx].alarmType = data;
      setInputValues(newInputValue);
    }
    if (itemData.status === 1) {
      (async () => {
        await updateLisStatusApi(itemData.alarmId, newInputValue.alarm[idx].alarmType, itemData.vol);
      })();
    }
  } else if (name === 'vol') {
    const newInputValue = JSON.parse(JSON.stringify(InputValues));
    const idx = newInputValue.alarm.findIndex((it) => it.alarmId === alarmId);
    if (idx > -1) {
      newInputValue.alarm[idx].vol = data;
      setInputValues(newInputValue);
    }
    if (itemData.status === 1) {
      (async () => {
        await updateLisStatusApi(itemData.alarmId, itemData.alarmType, newInputValue.alarm[idx].vol);
      })();
    }
  } else if (name === 'wardLocation') {
    setInputValues((oldData) => ({ ...oldData, wardLocation: data }));
  } else {
    const hospIndex = InputValues.hospital.index;
    const wardIndex = _.findIndex(hospitalWardList[hospIndex].wards, (item) => {
      return item.wardId === data;
    });
    setInputValues({ ...InputValues, [name]: { value: data, index: wardIndex } });
  }
};

export default function Mapping() {
  const classes = useStyles();
  const loginInfo = useSelector((state) => state.loginInfo);
  const [, setShowRingtoneBox] = useState(false);
  const [resetOpenDilog, setResetOpenDilog] = useState();
  const [hospitalWardList, setHospitalWardList] = useState(null);
  const [, setResetData] = useState();
  const [resetIndex, setResetIndex] = useState();
  const roleMap = useSelector((state) => state.roleMap);
  const userInfo = useGetUserInfo();
  const [adsList, setAdsList] = useState([]);
  // 检查提交时数据有问题的房间
  const [errorWardLocId, setErrorWardLocId] = useState([]);
  const getSysDataMappingList = async () => {
    try {
      const { result } =
        (await systemAPI.getSysDataMappingList(rewriteSettingRequestParams({ userId: loginInfo.userId }))) ?? {};
      setHospitalWardList(result);
      return result;
    } catch (error) {
      console.log('error', error);
      setHospitalWardList(null);
    }
  };
  const [InputValues, setInputValues] = useState({
    hospital: { value: '', index: -1 },
    ward: { value: '', index: -1 },
    enableYn: false,
    ipasMapping: [
      {
        hospCode: '',
        wardCode: '',
      },
    ], // {} => hospCode , wardCode
    srsMapping: [
      {
        hospCode: '',
        wardCode: '',
      },
    ], // {} => hospCode , wardCode
    // IP Address or Computer Name
    alarm: [
      {
        alarmId: null,
        alarmType: 1,
        machineHostnameIp: '',
        status: 2 /** status: 1:open,2: close */,
        showLis: false,
        vol: 1,
      },
    ],
    // tvMapping: [
    //   {
    //     hospCode: '',
    //     wardCode: '',
    //   },
    // ],
    wardLocation: [],
  });
  const adsLocation = useMemo(() => {
    return _.find(InputValues?.wardLocation, (item) => item.adsRoomType === 'W');
  }, [InputValues?.wardLocation]);
  const roomLocation = useMemo(() => {
    return _.filter(InputValues?.wardLocation, (item) => item.adsRoomType === 'R');
  }, [InputValues?.wardLocation]);

  const [HospitalCodeList, setHospitalCodeList] = useState(null);
  const getSysHospitalCodeList = async () => {
    try {
      const { result } = await systemAPI.sysHospitalCodeList();
      setHospitalCodeList(result);
    } catch {}
  };

  const [HospitalUnitList, setHospitalUnitList] = useState(null);
  const [ringtoneList] = useState([
    { text: 'Ringtone #1', value: 1 },
    { text: 'Ringtone #2', value: 2 },
    { text: 'Ringtone #3', value: 3 },
    { text: 'Ringtone #4', value: 4 },
    { text: 'Ringtone #5', value: 5 },
    { text: 'Ringtone #6', value: 6 },
    { text: 'Ringtone #7', value: 7 },
  ]);

  const [volumeLevel] = useState([
    { text: '1', value: 1 },
    { text: '2', value: 2 },
    { text: '3', value: 3 },
    { text: '4', value: 4 },
    { text: '5', value: 5 },
    { text: '6', value: 6 },
    { text: '7', value: 7 },
    { text: '8', value: 8 },
    { text: '9', value: 9 },
    { text: '10', value: 10 },
  ]);

  const getSysHospitalUnitList = async ({ hospitalCode }) => {
    try {
      const { result } = await systemAPI.sysHospitalUnitList({ hospitalCode: hospitalCode });
      setHospitalUnitList((o) => ({
        ...o,
        [hospitalCode]: Array.isArray(result)
          ? result.map((item) => ({ text: item.shortDesc, value: item.unitCode }))
          : [],
      }));
    } catch {}
  };
  const getHospitalUnit = (index) => {
    const hospitalCode = InputValues.srsMapping[index].hospCode;
    if (hospitalCode) {
      return HospitalUnitList?.[hospitalCode] ? HospitalUnitList[hospitalCode] : [];
    } else {
      return [];
    }
  };
  useEffect(() => {
    _.forEach(InputValues.srsMapping, (item) => {
      if (item.hospCode && !HospitalUnitList?.[item.hospCode]) {
        (async () => {
          await getSysHospitalUnitList({ hospitalCode: item.hospCode });
        })();
      }
    });
  }, [InputValues.srsMapping]);

  useEffect(() => {
    (async () => {
      await getSysHospitalCodeList();
      const result = await getSysDataMappingList();
      initInputValue(result);
    })();
  }, []);

  const initInputValue = (hospitalWardData) => {
    let hospital = { value: '', index: -1 };
    let ward = { value: '', index: -1 };
    let enableYn = false;
    setInputValues({
      hospital,
      ward,
      wardLocation: [],
    });
    if (Array.isArray(hospitalWardData) && hospitalWardData.length > 0) {
      const firstHosp = hospitalWardData.find((item, index) => {
        if (item.hospitalId === loginInfo.hospitalId) {
          hospital = { value: loginInfo?.hospitalId, index: index };
          return true;
        }
        return false;
      });
      if (firstHosp?.wards?.length > 0) {
        firstHosp.wards.find((item, index) => {
          if (item.wardId === loginInfo.wardId) {
            ward = { value: item.wardId, index: index };
            enableYn = item?.enableYn === 1;
            return true;
          }
          return false;
        });
      }
    }
    setInputValues({
      hospital: hospital,
      ward: ward,
      enableYn,
      ipasMapping: [], // {} => hospCode , wardCode
      srsMapping: [], // {} => hospCode , wardCode
      alarm: [],
      tvMapping: [],
      wardLocation: [],
    });
  };

  useMemo(() => {
    if (hospitalWardList) {
      const hospIndex = InputValues.hospital.index;
      const wardIndex = InputValues.ward.index;
      const { ipasMapping, srsMapping, wardId, alarm, tvMapping, wardLocation } =
        hospitalWardList?.[hospIndex]?.wards?.[wardIndex] ?? {};
      if (ipasMapping?.length === 0) {
        ipasMapping.push({
          hospCode: '',
          wardCode: '',
        });
      }
      if (srsMapping?.length === 0) {
        srsMapping.push({
          hospCode: '',
          wardCode: '',
        });
      }
      if (alarm?.length === 0) {
        alarm.push({
          alarmId: null,
          alarmType: 1,
          machineHostnameIp: '',
          status: 2,
          showLis: false,
          vol: 1,
        });
      }
      if (tvMapping?.length === 0) {
        tvMapping.push({
          hospCode: '',
          wardCode: '',
        });
      }
      if (wardLocation?.length === 0) {
        wardLocation.push({
          roomName: null,
          adsLocation: '',
          adsRoomType: 'W',
          adsWardLocationId: 0,
          id: getUUID(),
        });
        wardLocation.push({
          roomName: '',
          adsLocation: '',
          adsRoomType: 'R',
          adsWardLocationId: 0,
          id: getUUID(),
        });
      }
      setInputValues({
        ...InputValues,
        ipasMapping: ipasMapping || '',
        srsMapping: srsMapping || '',
        wardId,
        alarm: alarm || '',
        tvMapping: tvMapping || '',
        wardLocation: [],
      });
    }
  }, [InputValues.hospital.value, InputValues.ward.value]);

  const getWards = () => {
    const hospitalIndex = InputValues?.hospital?.index;
    if (hospitalIndex >= 0) {
      return _.sortBy(
        _.map(hospitalWardList?.[hospitalIndex]?.wards, (item) => item),
        ['wardName']
      );
    }
  };

  const updateLisStatusApi = async (alarmId, alarmType, vol) => {
    /**
     * actionType:
     * OPEN(1,"open")
     * CLOSE(2,"close")
     * TEST(3,"test")
     * HEALTHCHECK(4,"heanthCheck")
     */
    await systemAPI.updateLisStatus({
      actionType: 3,
      alarmId: alarmId,
      alarmType: alarmType,
      vol: vol,
    });
  };

  const inputChange = (name, type, alarmId, itemData) => {
    return (data) => {
      if (type === 'text') {
        const newInputValue = JSON.parse(JSON.stringify(InputValues));
        newInputValue[name[0]][name[1]][name[2]] = data.target.value;
        setInputValues(newInputValue);
      } else if (type === 'select') {
        handleSelectTypeInput({
          name,
          hospitalWardList,
          data,
          setInputValues,
          InputValues,
          alarmId,
          itemData,
          updateLisStatusApi,
        });
      } else if (type === 'drowSRSWardCode') {
        const newInputValue = JSON.parse(JSON.stringify(InputValues));
        newInputValue[name[0]][name[1]][name[2]] = data;
        setInputValues(newInputValue);
      } else if (type === 'drowSRSHospCode') {
        const newInputValue = JSON.parse(JSON.stringify(InputValues));
        newInputValue[name[0]][name[1]].wardCode = '';
        newInputValue[name[0]][name[1]][name[2]] = data;
        setInputValues(newInputValue);
      } else if (type === 'wardLocation') {
        const newValue = name[2] === 'select' ? data : data.target.value;
        setInputValues((prevValues) => ({
          ...prevValues,
          wardLocation: _.map(prevValues.wardLocation, (item) => ({
            ...item,
            [name[0]]: item.id === name[1] ? newValue : item[name[0]],
          })),
        }));
      }
    };
  };
  const updateSysDataMapping = async () => {
    try {
      const newData = { ...InputValues, enableYn: InputValues?.enableYn ? 1 : 0 };
      newData['wardId'] = newData['ward'].value;
      delete newData['hospital'];
      delete newData['ward'];

      console.log('-----request-----', newData);
      const { result } = await systemAPI.updateSysDataMapping({
        ...newData,
        wardLocation: _.filter(newData?.wardLocation, (item) => item.adsLocation),
      });
      console.log('-----Mapping save-----', result);
    } catch (error) {
      console.log('error', error);
    }
  };

  // 检查Locations的数据有没有问题
  const checkSubmitData = () => {
    // 如果房间只输了 Location, 但是没有输ADS Location,就不能提交
    const errorRoomLocation = _.filter(roomLocation, (item) => item?.roomName !== '' && item?.adsLocation === '');
    if (errorRoomLocation.length > 0) {
      setErrorWardLocId(_.map(errorRoomLocation, (item) => item.id));
      return false;
    }
    setErrorWardLocId([]);
    return true;
  };

  const saveClick = async () => {
    if (!checkSubmitData()) return;
    await updateSysDataMapping();
    const res = await getSysDataMappingList();

    const newData = { ...InputValues};
    const wardId = newData['ward'].value;
    const { hospitalId } = loginInfo;
    const hospIndex = res.findIndex((it) => it.hospitalId === hospitalId);
    if (res && hospIndex > -1) {
      const wards = res[hospIndex]?.wards;
      const wardIndex = wards.findIndex((it) => it.wardId === wardId);
      if (wardIndex > -1) {
        setInputValues({
          ...InputValues,
          alarm:
            wards[wardIndex]?.alarm.length > 0
              ? wards[wardIndex]?.alarm
              : [
                  {
                    alarmId: null,
                    alarmType: 1,
                    machineHostnameIp: '',
                    status: 2,
                    showLis: false,
                    vol: 1,
                  },
                ],
          ipasMapping:
            wards[wardIndex]?.ipasMapping.length > 0
              ? wards[wardIndex]?.ipasMapping
              : [
                  {
                    hospCode: '',
                    wardCode: '',
                  },
                ],
          srsMapping:
            wards[wardIndex]?.srsMapping.length > 0
              ? wards[wardIndex]?.srsMapping
              : [
                  {
                    hospCode: '',
                    wardCode: '',
                  },
                ],
          tvMapping:
            wards[wardIndex]?.tvMapping.length > 0
              ? wards[wardIndex]?.tvMapping
              : [
                  {
                    hospCode: '',
                    wardCode: '',
                  },
                ],
        });
      }
    }
  };
  const addSRSClick = () => {
    setInputValues({
      ...InputValues,
      srsMapping: [...(InputValues?.srsMapping ?? {}), { hospCode: '', wardCode: '' }],
    });
  };
  const SRSCtr = () => {
    return _.map(InputValues?.srsMapping, (item, index) => {
      return (
        <Box display="flex" mb="1.25rem" key={index}>
          <Box width="19.688rem" mr="1.25rem">
            <AutoCompleteInput
              id={`setting_mapping_srs_hospital_${index}`}
              placeholder={i18n.t('SETTING_SRS_HOSPITAL_CODE')}
              value={item?.hospCode}
              onChange={inputChange(['srsMapping', index, 'hospCode'], 'drowSRSHospCode')}
              disabled={InputValues.ward.index === -1}
              itemList={_.map(HospitalCodeList, (item) => ({ text: item, value: item }))}
            />
          </Box>
          <Box width="19.688rem">
            <AutoCompleteInput
              id={`setting_mapping_srs_ward_${index}`}
              placeholder={i18n.t('SETTING_SRS_UNIT_CODE')}
              value={item?.wardCode}
              onChange={inputChange(['srsMapping', index, 'wardCode'], 'drowSRSWardCode')}
              disabled={InputValues.ward.index === -1}
              itemList={getHospitalUnit(index)}
              // onFocus={focusHospitalUnit(index)}
            />
          </Box>
        </Box>
      );
    });
  };

  const APISStr = () => {
    return _.map(InputValues?.ipasMapping, (item, index) => {
      return (
        <Box display="flex" mb="1.25rem" key={index}>
          <Box width="19.688rem" mr="1.25rem">
            <InputBase
              id={`setting_mapping_api_hospital_${index}`}
              className={classes.InputBase}
              placeholder={i18n.t('SETTING_PLEASE_INPUT')}
              value={item?.hospCode}
              onChange={inputChange(['ipasMapping', index, 'hospCode'], 'text')}
              disabled={InputValues.ward.index === -1}
            />
          </Box>
          <Box width="19.688rem">
            <InputBase
              id={`setting_mapping_api_ward_${index}`}
              className={classes.InputBase}
              placeholder={i18n.t('SETTING_PLEASE_INPUT')}
              value={item?.wardCode}
              onChange={inputChange(['ipasMapping', index, 'wardCode'], 'text')}
              disabled={InputValues.ward.index === -1}
            />
          </Box>
        </Box>
      );
    });
  };

  // const Televisit = () => {
  //   return _.map(InputValues?.tvMapping, (item, index) => {
  //     return (
  //       <Box display="flex" mb="1.25rem" key={index}>
  //         <Box width="19.688rem" mr="1.25rem">
  //           <InputBase
  //             id={`setting_mapping_api_televisit_hosp_code_${index}`}
  //             className={classes.InputBase}
  //             placeholder={i18n.t('SETTING_PLEASE_INPUT')}
  //             value={item?.hospCode}
  //             onChange={inputChange(['tvMapping', index, 'hospCode'], 'text')}
  //             disabled={InputValues.ward.index === -1}
  //           />
  //         </Box>
  //         <Box width="19.688rem">
  //           <InputBase
  //             id={`setting_mapping_api_televisit_ward_code${index}`}
  //             className={classes.InputBase}
  //             placeholder={i18n.t('SETTING_PLEASE_INPUT')}
  //             value={item?.wardCode}
  //             onChange={inputChange(['tvMapping', index, 'wardCode'], 'text')}
  //             disabled={InputValues.ward.index === -1}
  //           />
  //         </Box>
  //       </Box>
  //     );
  //   });
  // };
  // 打开重置IP pop-up
  const resetHandler = (item, index) => {
    setResetOpenDilog(true);
    setResetData(item);
    setResetIndex(index);
  };
  // pop-up confirm  Btn
  const resetConfirmHandlerDialog = () => {
    setResetOpenDilog(false);
    const newIpAddressValue = JSON.parse(JSON.stringify(InputValues));
    setResetData({
      machineHostnameIp: '',
      showList: false,
      status: null,
      alarmType: null,
    });
    newIpAddressValue.alarm[resetIndex].alarmId = null;
    newIpAddressValue.alarm[resetIndex].machineHostnameIp = '';
    newIpAddressValue.alarm[resetIndex].alarmType = '';
    newIpAddressValue.alarm[resetIndex].state = null;
    newIpAddressValue.alarm[resetIndex].showLis = false;
    if (newIpAddressValue.alarm.length > 1) {
      let filterData = _.filter(newIpAddressValue.alarm, (item, index) => item.alarmType);
      newIpAddressValue.alarm = filterData;
    }
    setInputValues(newIpAddressValue);
  };
  // 重置IP
  const resetDialogHandler = useCallback(
    (type) => (value) => {
      switch (type) {
        case 'close':
          setResetOpenDilog(false);
          break;
        case 'open':
          setResetOpenDilog(true);
          break;
        case 'confirm':
          setResetOpenDilog(false);
          break;
        default:
          break;
      }
    },
    []
  );

  // connect button
  const connectHandler = async (item, index) => {
    try {
      await systemAPI.listConnect({ machineHostnameIp: item.machineHostnameIp });
      const newIpAddressValue = JSON.parse(JSON.stringify(InputValues));
      newIpAddressValue.alarm[index].showLis = true;
      newIpAddressValue.alarm[index].alarmType = 1;
      newIpAddressValue.alarm[index].status = 2;
      setInputValues(newIpAddressValue);
      setShowRingtoneBox(true);
    } catch (error) {
      console.log('error', error);
    }
  };
  // add input
  const addIPAdressClick = () => {
    setInputValues({
      ...InputValues,
      alarm: [
        ...(InputValues?.alarm ?? {}),
        { alarmType: null, machineHostnameIp: '', status: null, showLis: false, vol: 1 },
      ],
    });
  };
  // Alert light ON/OFF
  const changeAlertLightStatus = async (item, index) => {
    try {
      const newIpAddressValue = JSON.parse(JSON.stringify(InputValues));
      if (newIpAddressValue.alarm[index].status === 1) {
        newIpAddressValue.alarm[index].status = 2;
      } else {
        newIpAddressValue.alarm[index].status = 1;
      }
      await systemAPI.updateLisStatus({
        actionType: newIpAddressValue.alarm[index].status,
        alarmId: item.alarmId,
        alarmType: item.alarmType,
        vol: item.vol,
      });
      //  status 1:open  , status 2: close
      setInputValues(newIpAddressValue);
    } catch (error) {
      console.log('error', error);
    }
  };
  const IPAddress = () => {
    return _.map(InputValues?.alarm, (item, index) => {
      return (
        <Box display="flex" mb="1.25rem" key={index} alignItems="center">
          <Box width="19.688rem" mr="1.25rem" display="flex" alignItems="center" className={classes.inputBox}>
            <InputBase
              id={`setting_mapping_api_ipAddress_${index}`}
              placeholder={i18n.t('SETTING_ENTER_IP')}
              className={classes.inputBoxBase}
              value={item?.machineHostnameIp}
              onChange={inputChange(['alarm', index, 'machineHostnameIp'], 'text')}
            />
            {(item.showLis || item.alarmId) && (
              <ButtonBase
                id={`setting-reset-${index}`}
                className={classes.resetBtn}
                onClick={() => {
                  resetHandler(item, index);
                }}
              >
                {i18n.t('SETTING_RESET')}
              </ButtonBase>
            )}
          </Box>
          {item.machineHostnameIp && !item.showLis && !item.alarmId && (
            <Box>
              <ButtonBase
                id={`setting-connect-${index}`}
                className={classes.connectButton}
                onClick={() => {
                  (async () => {
                    await connectHandler(item, index);
                  })();
                }}
              >
                {i18n.t('SETTING_CONNECT')}
              </ButtonBase>
            </Box>
          )}
          {(item.alarmId || item.showLis) && (
            <>
                <Box width="19.688rem" mr="1.25rem">
                  <AutoCompleteSelect
                    id={`setting_mapping_ringtone${index}`}
                    placeholder={i18n.t('SETTING_RINGTONE')}
                    value={initValue(item.alarmType, 1)}
                    itemList={ringtoneList}
                    onChange={inputChange('ringtone', 'select', item.alarmId, item)}
                  />
                </Box>
                <Box width="9.938rem" mr="1.25rem">
                  <AutoCompleteSelect
                    id={`setting_mapping_volume_level${index}`}
                    placeholder={i18n.t('SETTING_MAPPING_VOLUME_LEVEL')}
                    value={initValue(item.vol, 1)}
                    itemList={volumeLevel}
                    onChange={inputChange('vol', 'select', item.alarmId, item)}
                  />
                </Box>
                <Box display="flex" alignItems="center">
                  <Box>
                    {item?.status === 1 ? (
                      <img src={lightNoImg} alt="" className={classes.alertLightImg} />
                    ) : (
                      <img src={lightOffImg} alt="" className={classes.alertLightImg} />
                    )}
                  </Box>
                  <Box width="6.5rem">
                    <Typography className={classes.alertLightText}>
                      {item?.status === 1 ? i18n.t('SETTING_ALERT_LIGHT_ON') : i18n.t('SETTING_ALERT_LIGHT_OFF')}
                    </Typography>
                  </Box>
                  <ButtonBase
                    className={classNames(
                      classes.alertLightButton,
                      item.status === 1 ? classes.alertLightButtonOFF : classes.alertLightButtonON,
                      !item.alarmId && classes.alertLightButtonDisable
                    )}
                    onClick={() => {
                      (async () => {
                        await changeAlertLightStatus(item, index);
                      })();
                    }}
                    disabled={!item.alarmId}
                    id={`setting-alght-btn${index}`}
                  >
                    {item?.status === 1 ? i18n.t('SETTING_OFF') : i18n.t('SETTING_ON')}
                  </ButtonBase>
                </Box>
            </>
          )}
        </Box>
      );
    });
  };
  const addIPASClick = () => {
    setInputValues({
      ...InputValues,
      ipasMapping: [...(InputValues?.ipasMapping ?? {}), { hospCode: '', wardCode: '' }],
    });
  };

  const isShowRingtone = () => {
    return Boolean(
      _.find(InputValues?.alarm, (item) => {
        return item.showLis || item.alarmId;
      })
    );
  };

  const handleChangeHideOriginalWard = (event) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      enableYn: event.target.checked,
    }));
  };

  useEffect(() => {
    if (isArray(hospitalWardList)) {
      const currentHospital = _.find(hospitalWardList, (item) => item.hospitalId === InputValues.hospital.value);
      if (isArray(currentHospital?.wards)) {
        const currentWard = _.find(currentHospital?.wards, (item) => item.wardId === InputValues.ward.value);
        setInputValues((oldData) => {
          let tempWardLocation = _.map(currentWard?.wardLocation ?? [], (item) => ({ ...item, id: getUUID() }));
          if (!_.some(tempWardLocation, (item) => item.adsRoomType === 'W')) {
            tempWardLocation.push({
              roomName: null,
              adsLocation: '',
              adsRoomType: 'W',
              adsWardLocationId: 0,
              id: getUUID(),
            });
          }
          if (!_.some(tempWardLocation, (item) => item.adsRoomType === 'R')) {
            tempWardLocation.push({
              roomName: '',
              adsLocation: '',
              adsRoomType: 'R',
              adsWardLocationId: 0,
              id: getUUID(),
            });
          }
          return {
            ...oldData,
            wardLocation: tempWardLocation,
            enableYn: currentWard?.enableYn === 1,
          };
        });
      }
    }
  }, [InputValues.hospital.value, InputValues.ward.value, hospitalWardList]);

  const getADSList = useCallback(async () => {
    try {
      const { result } = await systemAPI.getAdsList({ hospitalCode: userInfo.hospCode });
      setAdsList(result?.ADSInfoDetails);
    } catch (error) {
      console.log(error);
    }
  }, [userInfo.hospCode]);

  useEffect(() => {
    (async () => {
      await getADSList();
    })();
  }, [getADSList]);

  const adsItemList = useMemo(() => {
    if (isArray(adsList) && adsList.length > 0) {
      return _.map(adsList, (item) => ({
        text: item.locationDesc,
        value: item.locationCode,
      }));
    }
    return [];
  }, [adsList]);

  const handleAddRoom = () => {
    setInputValues((prevValues) => ({
      ...prevValues,
      wardLocation: [
        ...prevValues.wardLocation,
        {
          roomName: '',
          adsLocation: '',
          adsRoomType: 'R',
          adsWardLocationId: 0,
          id: getUUID(),
        },
      ],
    }));
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.databaseMapping}>{i18n.t('SETTING_WARD_INFO')}</Typography>
      <Box display="flex" mb="0.2rem">
        <Box width="19.688rem" mr="1.25rem">
          <Typography className={classes.label}>{i18n.t('SETTING_HOSPITAL')}</Typography>
          <AutoCompleteSelect
            id="setting_mapping_hospitalname"
            placeholder={i18n.t('SETTING_HOSPITAL')}
            value={InputValues.hospital.value}
            itemList={
              Array.isArray(hospitalWardList) &&
              hospitalWardList.map((item) => {
                return { text: item.hospitalName, value: item.hospitalId };
              })
            }
            onChange={inputChange('hospital', 'select')}
          />
        </Box>
        <Box width="19.688rem" mr="1.25rem">
          <Typography className={classes.label}>{i18n.t('SETTING_WARD')}</Typography>
          <AutoCompleteInput
            id="setting_mapping_wardname"
            placeholder={i18n.t('SETTING_WARD')}
            value={InputValues.ward.value}
            itemList={_.map(getWards(), (item) => ({ text: item.wardName, value: item.wardId }))}
            onChange={inputChange('ward', 'select')}
          />
        </Box>
      </Box>
      <Typography className={classes.databaseMapping}>{i18n.t('SETTING_DATABASE_MAPPING')}</Typography>
      <Box display="flex">
        <Box width="19.688rem" mr="1.25rem">
          <Typography className={classes.label}>{i18n.t('SETTING_IPAS_HOSPITAL_CODE')}</Typography>
        </Box>
        <Box width="19.688rem">
          <Typography className={classes.label}>{i18n.t('SETTING_IPAS_WARD_LOCATION')}</Typography>
        </Box>
      </Box>
      <Box display="flex">
        <Box display="flex" flexDirection="column">
          {APISStr()}
          <ButtonBase
            id="setting_mapping_api_addrow"
            className={classes.addSRS}
            onClick={addIPASClick}
            style={{ marginBottom: '1.563rem' }}
          >
            <AddIcon className={classes.addIcon} />
            {i18n.t('ADD_IPAS_CODE_ROW')}
          </ButtonBase>
        </Box>
      </Box>
      <Box display="flex">
        <Box width="19.688rem" mr="1.25rem">
          <Typography className={classes.label}>{i18n.t('SETTING_SRS_HOSPITAL_CODE')}</Typography>
        </Box>
        <Box width="19.688rem">
          <Typography className={classes.label}>{i18n.t('SETTING_SRS_UNIT_CODE')}</Typography>
        </Box>
      </Box>
      <Box display="flex">
        <Box display="flex" flexDirection="column">
          {SRSCtr()}
          <ButtonBase id="setting_mapping_srs_addrow" className={classes.addSRS} onClick={addSRSClick}>
            <AddIcon className={classes.addIcon} />
            {i18n.t('SETTING_ADD_SRS_CODE_ROW')}
          </ButtonBase>
          <Box display="flex">
            <Box width="19.688rem" mr="1.25rem">
              <Typography className={classes.label}>Locations (for Equipment requester ward)</Typography>
            </Box>
            <Box width="19.688rem">
              <Typography className={classes.label}>{i18n.t('SETTING_ADS_TITLE')}</Typography>
            </Box>
          </Box>
          {roomLocation.map((item) => (
            <Box display="flex" mb="1.25rem" key={item.id}>
              <Box width="19.688rem" mr="1.25rem">
                <InputBase
                  className={classes.InputBase}
                  placeholder={i18n.t('SETTING_PLEASE_INPUT')}
                  value={item?.roomName}
                  onChange={inputChange(['roomName', item?.id, 'input'], 'wardLocation')}
                />
              </Box>
              <Box width="19.688rem">
                <AutoCompleteInput
                  placeholder={i18n.t('SETTING_ADS_PLACEHOLDER')}
                  value={item?.adsLocation}
                  onChange={inputChange(['adsLocation', item?.id, 'select'], 'wardLocation')}
                  itemList={adsItemList}
                  errorMsg={errorWardLocId?.includes(item?.id) ? 'Invalid ADS Location.' : ''}
                />
              </Box>
            </Box>
          ))}
          <ButtonBase id="setting_mapping_srs_addrow" className={classes.addLocation} onClick={handleAddRoom}>
            <AddIcon className={classes.addIcon} />
            Add Locations
          </ButtonBase>
          <FormControlLabel
            control={<Checkbox />}
            label="Hide original Ward in requester"
            className={classes.checkBox}
            checked={InputValues?.enableYn}
            onChange={handleChangeHideOriginalWard}
          />
          {roleMap[authNameE.setting_ADS_location] && (
            <Box display="flex" mb="1.25rem" flexDirection="column">
              <Box width="19.688rem" mr="1.25rem">
                <Typography className={classes.label}>{i18n.t('SETTING_ADS_TITLE')}</Typography>
              </Box>
              <Box width="19.688rem" mr="1.25rem">
                <AutoCompleteInput
                  placeholder={i18n.t('SETTING_ADS_PLACEHOLDER')}
                  value={adsLocation?.adsLocation}
                  onChange={inputChange(['adsLocation', adsLocation?.id, 'select'], 'wardLocation')}
                  itemList={adsItemList}
                />
              </Box>
            </Box>
          )}
          {/* 只有Hospital Admin才可以操作 */}
          {roleMap[authNameE.setting_manage_lis] && (
            <Box display="flex">
              <Box width="19.688rem" mr="1.25rem" display="flex">
                <Typography className={classes.label}>{i18n.t('SETTING_WORKSTATIN_FOR_ALERT_LIGHT')}</Typography>
                <LongRemark
                  content={
                    <div>
                      <div> {i18n.t('SETTING_TIPS_YOU_NEED_TO_ENTER_THE_HOST_NAME_OR_IP')} </div>
                      <br />
                      <div>{i18n.t('SETTING_TIPS_YOU_NEED_TO_ENTER_THE_HOST_NAME_OR_IP_ADDRESS')}</div>
                    </div>
                  }
                  placement="right"
                />
              </Box>
              {isShowRingtone() && (
                <Box display="flex">
                  <Box width="19.688rem" mr="1.25rem" display="flex">
                    <Typography className={classes.label}>{i18n.t('SETTING_RINGTONE')}</Typography>
                  </Box>
                  <Box width="9.938rem" mr="1.25rem" display="flex">
                    <Typography className={classes.label}>{i18n.t('SETTING_MAPPING_VOLUME_LEVEL')}</Typography>
                    <LongRemark
                      content={
                        <div dangerouslySetInnerHTML={{ __html: i18n.t('SETTING_MAPPING_VOLUME_LEVEL_REMARKS') }} />
                      }
                      placement="right"
                    />
                  </Box>
                  <Box width="19.688rem" mr="1.25rem" display="flex">
                    <Typography className={classes.label}>{i18n.t('SETTING_ALERT_LIGHT_STATUS')}</Typography>
                    <LongRemark
                      content={
                        <div>
                          <div>{i18n.t('SETTING_TIPS_THIS_IS_ALERT_LINGHT_TESTING_SWITCH')}</div>
                          <br />
                          <div>{i18n.t('SETTING_TIPS_THIS_IS_ALERT_LINGHT_TESTING_SWITCH_SOUND')}</div>
                        </div>
                      }
                      placement="right"
                    />
                  </Box>
                </Box>
              )}
            </Box>
          )}
          {roleMap[authNameE.setting_manage_lis] && (
            <>
              {IPAddress()}
              <ButtonBase id="setting_mapping_srs_addrow" className={classes.addSRS} onClick={addIPAdressClick}>
                <AddIcon className={classes.addIcon} />
                {i18n.t('SETTING_IP_ADDRESS_OR_COMPUTER_NAME')}
              </ButtonBase>
            </>
          )}
          {/* televisit */}
          {/* <Box>
            <Box display="flex">
              <Box width="19.688rem" mr="1.25rem">
                <Typography className={classes.label}>Televisit hosp code</Typography>
              </Box>
              <Box width="19.688rem">
                <Typography className={classes.label}>Televisit ward code</Typography>
              </Box>
            </Box>
            <Box display="flex">
              <Box display="flex" flexDirection="column">
                {Televisit()}
                <ButtonBase
                  id="setting_mapping_api_addrow"
                  className={classes.addSRS}
                  onClick={addTeleVisitClick}
                  style={{ marginBottom: '1.563rem' }}
                >
                  <AddIcon className={classes.addIcon} />
                  Add more mapping section
                </ButtonBase>
              </Box>
            </Box>
          </Box> */}
          <Box display="flex" justifyContent="flex-end" alignItems="center" mt="3.125rem">
            {InputValues.ward.index !== -1 ? (
              <ButtonBase
                id="setting_mapping_save"
                className={classes.save}
                onClick={() => {
                  (async () => {
                    await saveClick();
                  })();
                }}
                disabled={InputValues.ward.index === -1}
              >
                {i18n.t('SETTING_SAVE')}
              </ButtonBase>
            ) : null}
          </Box>
        </Box>
      </Box>
      {resetOpenDilog && (
        <ResetDialog dialogCloseHandler={resetDialogHandler('close')} dialogFinishHandler={resetConfirmHandlerDialog} />
      )}
    </div>
  );
}
